import { render } from "./Live.vue?vue&type=template&id=4153ec9c"
import script from "./Live.vue?vue&type=script&lang=ts"
export * from "./Live.vue?vue&type=script&lang=ts"

import "./Live.vue?vue&type=style&index=0&id=4153ec9c&lang=less"
script.render = render

export default script